import { Modal } from "bootstrap";

import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from "react";

import Select from "react-select";

import {
    useForm,
    Controller,
} from "react-hook-form";

import { toast } from "react-toastify";

import * as b2cleadService from "../../Services/b2cleadService";

const B2CBulkPipelineModal = forwardRef(
    (props, ref) => {

        const {
            selectedLeads,
            setSelectedLeads,
            getLeadData,
        } = props;

        const {
            control,
            handleSubmit,
            reset,
            formState: { errors },
        } = useForm({
            mode: "onSubmit",
        });

        const modalRef = useRef(null);

        const bsModal = useRef(null);

        // STATES
        const [pipelineOptions, setPipelineOptions] = useState([]);

        const [submitLoader, setSubmitLoader] = useState(false);

        // CLOSE MODAL
        const handleClose = () => {

            reset();

            bsModal.current?.hide();

        };

        // MODAL HANDLE
        useImperativeHandle(ref, () => ({

            toggle() {

                if (!bsModal.current) {

                    bsModal.current =
                        new Modal(
                            modalRef.current
                        );

                }

                bsModal.current.show();

                getPipelineOptions();

            },

            close() {

                handleClose();

            },

        }));

        // GET PIPELINE OPTIONS
        const getPipelineOptions = () => {

            b2cleadService

                .leadpipelineoptions()

                .then((res) => {

                    if (
                        res?.data?.status ===
                        "success"
                    ) {

                        const options =
                            res?.data?.data?.map(
                                (item) => ({

                                    label:
                                        item?.name,

                                    value:
                                        item?.name,

                                })
                            );

                        setPipelineOptions(
                            options
                        );

                    }

                })

                .catch((err) => {

                    console.log(
                        "PIPELINE ERROR",
                        err
                    );

                });

        };

        // SUBMIT
        const onSubmit = (data) => {

            setSubmitLoader(true);

            const formData =
                new FormData();

            formData.append(
                "leadPipeline",
                data?.leadPipeline?.value
            );

            formData.append(
                "leadArray",
                JSON.stringify(
                    selectedLeads
                )
            );

            b2cleadService

                .updatepipeline(
                    formData
                )

                .then((res) => {

                    if (
                        res?.data?.status === "success"
                    ) {

                        toast.success(
                            res?.data?.message ||
                            "Pipeline Updated Successfully"
                        );

                        handleClose();
                        setSelectedLeads([]);
                        getLeadData();

                    }

                })

                .catch((err) => {

                    console.log(
                        "UPDATE ERROR",
                        err
                    );

                    toast.error(
                        "Failed To Update Lead Source"
                    );

                })

                .finally(() => {

                    setSubmitLoader(false);

                });

        };

        return (

            <div
                className="modal fade"
                ref={modalRef}
                tabIndex="-1"
                aria-hidden="true"
                style={{
                    background:
                        "rgba(15,23,42,0.55)",

                    backdropFilter:
                        "blur(5px)",
                }}
            >

                <div className="modal-dialog modal-lg modal-dialog-centered">

                    <div className="modal-content border-0 rounded-4">

                        {/* HEADER */}
                        <div
                            className="modal-header border-0 text-white"
                            style={{
                                background:
                                    "linear-gradient(135deg,#2563eb,#1d4ed8)",
                            }}
                        >

                            <div>

                                {/* <h4 className="modal-title fw-bold text-dark mb-1">

                                    Bulk Lead Source

                                </h4> */}

                                <p className="mb-0 small opacity-75">

                                    Update pipeline for selected leads

                                </p>

                            </div>

                            <button
                                type="button"
                                className="btn btn-light rounded-circle position-absolute"
                                style={{
                                    top: "10px",
                                    right: "18px",
                                    width: "38px",
                                    height: "38px",
                                }}
                                onClick={
                                    handleClose
                                }
                            >

                                <i className="fa fa-times"></i>

                            </button>

                        </div>

                        {/* FORM */}
                        <form
                            onSubmit={handleSubmit(
                                onSubmit
                            )}
                        >

                            {/* BODY */}
                            <div className="modal-body p-4">

                                <div className="row g-4">

                                    {/* LEAD SOURCE */}
                                    <div className="col-md-12">

                                        <label className="form-label fw-semibold">

                                            Select Pipeline

                                            <span className="text-danger ms-1">
                                                *
                                            </span>

                                        </label>

                                        <Controller
                                            name="leadPipeline"
                                            control={control}
                                            rules={{
                                                required:
                                                    "Please select atleast one pipeline",
                                            }}
                                            render={({ field }) => (

                                                <Select
                                                    {...field}
                                                    placeholder="Select Pipeline"
                                                    options={pipelineOptions}
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    value={field.value || null}
                                                    isClearable
                                                    isSearchable
                                                />

                                            )}
                                        />

                                        {errors.leadPipeline && (

                                            <small className="text-danger fw-semibold">

                                                {
                                                    errors
                                                        .leadPipeline
                                                        .message
                                                }

                                            </small>

                                        )}

                                        {errors.leadSource && (

                                            <small className="text-danger fw-semibold">

                                                {
                                                    errors
                                                        .leadSource
                                                        .message
                                                }

                                            </small>

                                        )}

                                    </div>

                                </div>

                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer border-0 px-4 pb-4">

                                <button
                                    type="button"
                                    className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold"
                                    onClick={
                                        handleClose
                                    }
                                >

                                    Close

                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-sm btn-primary rounded-pill px-4 fw-semibold shadow-sm"
                                    disabled={
                                        submitLoader
                                    }
                                >

                                    {submitLoader
                                        ? "Updating..."
                                        : "Save"}

                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            </div>
        );
    }
);

export default B2CBulkPipelineModal;